// extracted by mini-css-extract-plugin
module.exports = {"commonDynamicHeading":"style_commonDynamicHeading__AcuMB"};